(function () {
  class MaxPlayIntroPopup extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;

      this._level = 0;

      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._upgradeBacker = resourceManager.get("upgradeBacker");
      this._upgradeBacker.alpha = 0;
      this._upgradeBacker.visible = false;

      this._pressStartBox = resourceManager.get("maxPlayIntroContainer:maxPlayIntroPopup:pressStartColourBox");
      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      const continueText = resourceManager.get("maxPlayIntroContainer:maxPlayIntroPopup:continueContainer");

      gsap.to(continueText, {
        duration: 0.8,
        pixi: { scaleX: 0.92, scaleY: 0.92 },
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });
    }

    setup() {
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
    }

    showPopup() {
      this.visible = true;

      this.setup();

      this._upgradeBacker.alpha = 0;
      this._upgradeBacker.visible = true;
      this.fadeIn(this._upgradeBacker, 0.5, 1, 0);

      this.floatIn(this, 0, 1.5);
      this.fadeIn(this, 1, 0.3, 0);

      let self = this;
      timerManager.addTimeout(700, function () {
        self.setActive();
      });

      messageBus.post("game:modal", { reason: "Platform Popup Open", data: "Platform Popup Open" });
      soundManager.play("dialogIn");
    }

    floatIn(object, delay, duration) {
      gsap.fromTo(
        object,
        {
          x: 0,
          y: 500,
        },
        {
          delay,
          duration,
          ease: "elastic.out(1.0, 0.4)",
          x: 0,
          y: 0,
        }
      );
    }

    fadeIn(object, alpha, duration, delay) {
      gsap.fromTo(
        object,
        {
          alpha: 0,
        },
        {
          delay: delay,
          duration: duration,
          alpha: alpha,
          onStart: () => {
            object.visible = true;
          },
        }
      );
    }

    bounceIn(object, delay, duration, scale) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: duration ?? 1,
          ease: "Bounce.easeOut",
          x: scale ?? 1,
          y: scale ?? 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }

    setActive() {
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.closeDialog.bind(this);
    }

    closeDialog() {
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      soundManager.play("buttonPressV1");

      soundManager.play("dialogOut");

      this.clearIntro();
    }

    clearIntro() {
      this.fadeOut(this._upgradeBacker, 0.8);
      this.fadeOut(this, 0.8);
      this.riseUp(this, 0.8);
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: "power1.in",
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;

          messageBus.post("game:modal", { data: "Platform Popup Close" });
        },
      });
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, "x"),
        y: gsap.getProperty(object, "y"),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: "power4.in",
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }
        },
      });
    }
  }

  let maxPlayIntroPopupCreator = function (json) {
    return new MaxPlayIntroPopup();
  };

  let maxPlayIntroPopupInitialiser = function (json) {};

  let maxPlayIntroPopupFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "maxPlayIntroPopup",
    maxPlayIntroPopupCreator,
    maxPlayIntroPopupInitialiser,
    maxPlayIntroPopupFilesRequired
  );
})();
